const data = [
    { 
      id: 1, 
      name: "Genérico"
    },
    { 
      id: 2, 
      name: "Nome usuário"
    },
    { 
      id: 3, 
      name: "Registro usuário"
    },
    { 
      id: 4, 
      name: "Valor"
    },
    { 
      id: 5, 
      name: "ID"
    },
    { 
      id: 6, 
      name: "Data"
    },
  ];
  
  export default [...data];